import create from 'zustand';

interface IComponentsHeightsState {
  readonly siteNotificationsHeight: number;
  readonly USPsStripHeight: number;
  readonly stickyBuyBarHeight: number;
  readonly tabbedProductNavigationTopHeight: number;
  readonly tabbedProductNavigationBottomHeight: number;
  readonly setSiteNotificationsHeight: (height: number) => void;
  readonly setUSPsStripHeight: (height: number) => void;
  readonly setStickyBuyBarHeight: (height: number) => void;
  readonly setTabbedProductNavigationTopHeight: (height: number) => void;
  readonly setTabbedProductNavigationBottomHeight: (height: number) => void;
}

const useComponentsHeightsStore = create<IComponentsHeightsState>((set) => ({
  siteNotificationsHeight: 0,
  USPsStripHeight: 0,
  stickyBuyBarHeight: 0,
  tabbedProductNavigationTopHeight: 0,
  tabbedProductNavigationBottomHeight: 0,
  setSiteNotificationsHeight: (height: number) =>
    set({ siteNotificationsHeight: height }),
  setUSPsStripHeight: (height: number) => set({ USPsStripHeight: height }),
  setStickyBuyBarHeight: (height: number) =>
    set({ stickyBuyBarHeight: height }),
  setTabbedProductNavigationTopHeight: (height: number) =>
    set({ tabbedProductNavigationTopHeight: height }),
  setTabbedProductNavigationBottomHeight: (height: number) =>
    set({ tabbedProductNavigationBottomHeight: height }),
}));

export default useComponentsHeightsStore;
